/*
 * @Author: Hong.Zhang
 * @Date: 2024-11-26 14:03:38
 * @Description:
 */
import { PRODUCT_KEY_2_PRODUCT_NAME } from '@/constants/product';
import Cookies from 'js-cookie';
import store from 'store2';

export const LOCAL_FAST_QUOTE = 'fast_quote';
export const LOCAL_FORM_DATA = 'form_data';
export const LOCAL_TOKEN = 'token';
export const LOCAL_PRODUCT_KEY = 'product_key';
export const LOCAL_PLAN = 'plan';
export const LOCAL_PROFILE = 'profile';
export const LOCAL_FROM_DEEPLINK = 'from_deeplink';

export const local = {
  set(key: string, value: any) {
    store.set(key, value);
  },
  get(key: string) {
    return store.get(key);
  },
  remove(key: string) {
    store.remove(key);
  },
  clear() {
    store.clear();
  },
};

export const getProductName = () => {
  const productKey = local.get(LOCAL_PRODUCT_KEY);
  const productName = PRODUCT_KEY_2_PRODUCT_NAME[productKey];
  return productName;
};

export const productLevelLocal = {
  set(key: string, value: any) {
    const productName = getProductName();
    store.set(`${productName}_${key}`, value);
  },
  get(key: string) {
    const productName = getProductName();
    return store.get(`${productName}_${key}`);
  },
  remove(key: string) {
    const productName = getProductName();
    store.remove(`${productName}_${key}`);
  },
  clear() {
    const productName = getProductName();
    // Clear only the keys related to the product
    Object.keys(store).forEach((sessionKey) => {
      if (sessionKey.startsWith(`${productName}_`)) {
        store.remove(sessionKey);
      }
    });
  },
};

export const COOKIE_FIRST_AUTH_TOKEN = 'first_auth_token';
export const COOKIE_KREDIVO_USER_ID = 'kredivo_user_id';

export const cookie = {
  set(key: string, value: any) {
    Cookies.set(key, value, {
      path: '/',
      expires: 1,
    });
  },
  get(key: string) {
    return Cookies.get(key);
  },
  remove(key: string) {
    Cookies.remove(key);
  },
  clear() {
    Object.keys(Cookies.get()).forEach((key) => {
      Cookies.remove(key);
    });
  },
};
